module.exports = __webpack_public_path__ + "glyphicons-social-regular.c4478a1842916fc70377.eot";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.eot
// module id = ../../../../../src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.eot
// module chunks = 2